import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import BackToTop from '../components/backToTop/BackToTop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
import QuotePolicyList from '../components/admin/QuotePolicyList';
/*import TagManager from 'react-gtm-module';*/
export default function YourAccount(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedQuoteType, setSelectedQuoteType] = useState<string>();
    const [selectedStatus, setSelectedStatus] = useState<string>();
    const [quoteTypeError, setQuoteTypeError] = useState<string | null>(null);
    const [statusError, setStatusError] = useState<string | null>(null);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    let blankList = { renewals: [], policies: [], quotes: [], incompletes: [] }

    const [quotesAndPolicies, setQuotesAndPolicies] = useState(blankList);
    const [quotesAndPoliciesLoaded, setQuotesAndPoliciesLoaded] = useState(false);
    const [openedAccordion, setOpenedAccordion] = useState("");
    const [pageLoaded, setPageLoaded] = useState(false);

    var siteConfig = JSON.parse(localStorage.getItem('siteConfig') || "{}");

    useEffect(() => {
        if (!localStorage.getItem('userData')) navigate('/Login')
        props.setSidebarVisibility(false);
        getQuotesAndPolicies();
        localStorage.removeItem("paymentDetails");
        localStorage.removeItem("selectedQuote");
        localStorage.removeItem("quotes");
        localStorage.removeItem("customerDetails");
        localStorage.removeItem("questions");
        localStorage.removeItem("trade");
        localStorage.removeItem("status");
        localStorage.removeItem("deviceDetectionID");
        localStorage.removeItem("assumptions");
        localStorage.removeItem("realexCardID");
        localStorage.removeItem("payAnnual");
        localStorage.removeItem("policyRef");
        localStorage.setItem("gclid", "");


        fetch(`${apiBaseUrl}customer/GetBrowserInfo`)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                localStorage.setItem('browserType', data.browserName);
                localStorage.setItem('deviceType', data.deviceType);
                localStorage.setItem('isMobile', data.isMobile);
            })
            .catch((error) => {

            })
    }, [])

    const updateSelectedQuoteType = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedQuoteType(e.target.value);
    }
    const updateSelectedStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedStatus(e.target.value);
    }

    const startNewQuote = async () => {
        if (!selectedQuoteType || !selectedStatus) {
            !selectedQuoteType ? setQuoteTypeError("Please select a product type") : setQuoteTypeError(null)
            !selectedStatus ? setStatusError("Please select a business status") : setStatusError(null)
            return;
        }

        try {
            const userData = JSON.parse(localStorage.getItem('userData') || '');
            const email = userData.email;
            if (userData.insuredPartyIds.length > 0) {

                fetch(`${apiBaseUrl}customer/GetCustomerByEmail?email=${email}`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'text/plain'
                    },
                })
                    .then(response => {
                        return response.json();
                    }).then(customerDetails => {
                        delete customerDetails.extensionData;
                        delete customerDetails.address.extensionData;
                        customerDetails.webReference = selectedQuoteType;

                        //extra params
                        customerDetails.businessTelephoneNumber = "";
                        customerDetails.homeTelephoneNumber = "";

                        localStorage.setItem('customerDetails', JSON.stringify(customerDetails));
                        localStorage.setItem('trade', JSON.stringify({
                            "description": "",
                            "webBranding": selectedQuoteType,
                            "keywords": "customadded",
                            "priority": "1",
                            "products": selectedQuoteType
                        }));
                        localStorage.setItem('status', selectedStatus || '');
                        navigate("/Loading", {
                            state: {
                                pageToLoad: "/YourBusiness",
                                loadingTitle: "Loading",
                                loadingMessage: "Retrieving questions",
                            }
                        });
                    });
            } else {
                window.location.href = `${window.location.origin}/AboutYou?type=${selectedStatus}&webReference=${selectedQuoteType}`;
            }
        } catch {

        }

    }

    useEffect(() => {
        if (openedAccordion !== "" && pageLoaded) {
            document.getElementsByClassName(openedAccordion.toLowerCase().replaceAll(" ", "-"))[0].scrollIntoView();
        }

        if (openedAccordion !== "") {
            setPageLoaded(true);
        }
    }, [openedAccordion])

    const openedAccordionChanged = (sectionName: string) => {
        if (sectionName === openedAccordion) {
            setOpenedAccordion("");
        } else {
            setOpenedAccordion(sectionName);
            
        }
    }

    const getQuotesAndPolicies = () => {
        const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;

        fetch(`${apiBaseUrl}admin/AllQuotesAndPolicies`, {
            method: "POST",
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({ insuredPartyIdsList: userData.insuredPartyIds.toString(), agentIds: siteConfig.agentIDs })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                let responseData = JSON.parse(data.object);

                if (data.success) {
                    if (responseData.renewals != null && responseData.policies != null && responseData.quotes != null && responseData.incompletes != null) {
                        setQuotesAndPolicies(responseData);
                        let activeAccordion = "";
                        if (responseData.incompletes.length > 0)
                            activeAccordion = "Incomplete Quotes";
                        if (responseData.quotes.length > 0)
                            activeAccordion = "Current Quotes";
                        if (responseData.policies.length > 0)
                            activeAccordion = "Purchased Policies";
                        if (responseData.renewals.length > 0)
                            activeAccordion = "Ready to Renew";

                        setOpenedAccordion(activeAccordion);
                    }
                }
                setQuotesAndPoliciesLoaded(true);
            }).catch((error) => {

            });

    }

    const getWebReference = (endOfReference: string) => {
        return `${siteConfig.activeSite}${endOfReference}`;
    }

    const productEnabled = (endOfReference: string) => {
        var enabledProducts = siteConfig.enabledProducts.split(",");
        return enabledProducts.includes(endOfReference);
    }

    return (
        <>
            <div className="form-container">
                <div className="admin-section-header your-account-header">
                    <div className="account-h1">
                        <h1>Your Account</h1>
                    </div>
                    <div className="account-buttons">
                        <button className="btn primary" onClick={() => navigate('/ChangePassword')}>Change Password</button>
                        <button className="btn back" onClick={props.logout}>Log out</button>
                    </div>
                </div>
                <p>Welcome!</p>
                <p>Your personal home page allows you to view saved quotations and existing policies, or search for new quotations from our insurance service.</p>

                <div className="admin-section-header">
                    <h1>Get a New Quote</h1>
                </div>
                <div className="quote-section">

                    <div className="question">
                        <label>Product type</label>
                        <br />
                        <select
                            className="quote-dropdown"
                            value={selectedQuoteType}
                            onChange={updateSelectedQuoteType}
                        >
                            <option selected disabled hidden />
                            {productEnabled("TL") &&
                                <option value={getWebReference("TL")} >Tradesman Liability</option>
                            }
                            {productEnabled("SC") &&
                                <option value={getWebReference("SC")}>Small Business</option>
                            }
                            {productEnabled("PI") &&
                                <option value={getWebReference("PI")}>Professional Indemnity</option>
                            }
                            {productEnabled("PO") &&
                                <option value={getWebReference("PO")}>Property Owners</option>
                            }
                            {productEnabled("CA") &&
                                <option value={getWebReference("CA")}>Contractors All Risks</option>
                            }
                            {productEnabled("SI") &&
                                <option value={getWebReference("SI")}>Shop Insurance</option>
                            }
                            {productEnabled("RPO") &&
                                <option value={getWebReference("RPO")}>Residential Property Owners</option>
                            }
                        </select>
                        {quoteTypeError && <div className="input-error-message"><FontAwesomeIcon icon={faCircleExclamation} /> {quoteTypeError}</div>}
                    </div>
                    <div className="question">
                        <label>Your business is a</label>
                        <br />
                        <select
                            className="quote-dropdown"
                            value={selectedStatus}
                            onChange={updateSelectedStatus}
                        >
                            <option selected disabled hidden/>
                            <option value="limited">Limited Company</option>
                            <option value="partner">Partnership</option>
                            <option value="trader">Sole Trader</option>
                        </select>
                        {statusError && <div className="input-error-message"><FontAwesomeIcon icon={faCircleExclamation} /> {statusError}</div>}
                    </div>
                    <button className="btn primary" onClick={startNewQuote}>Get new quote</button>
                </div>

                <div className="admin-section-header">
                    <h1>Your Policies and Quotations</h1>
                </div>
                <p>Listed below are your saved quotations and current policies. From this page simply click on the relevant 'select' button next to your quotation or policy, then choose from one of the options below. Please note all saved quotes will be deleted after 30 days.</p>
                {quotesAndPoliciesLoaded &&
                    <>
                        {quotesAndPolicies.renewals.length > 0 &&
                            <QuotePolicyList title="Ready to Renew" itemList={quotesAndPolicies.renewals} noneMessage="" openedAccordionChanged={openedAccordionChanged} openedAccordion={openedAccordion} />
                        }
                        <QuotePolicyList title="Purchased Policies" itemList={quotesAndPolicies.policies} noneMessage="You have not purchased any policies yet. Check the 'Current Quotes' and 'Incomplete Quotes' sections below for any quotes you may have started. Alternatively you can start a new quote using the 'Get New Quote' section above." openedAccordionChanged={openedAccordionChanged} openedAccordion={openedAccordion} />
                        <QuotePolicyList title="Current Quotes" itemList={quotesAndPolicies.quotes} noneMessage="You do not have any current quotes. Check the 'Incomplete Quotes' section below for any quotes you may have started. Alternatively you can start a new quote using the 'Get New Quote' section above. Any policies you have purchased will appear in the 'Purchased Policies' Section." openedAccordionChanged={openedAccordionChanged} openedAccordion={openedAccordion} />
                        <QuotePolicyList title="Incomplete Quotes" itemList={quotesAndPolicies.incompletes} noneMessage="You do not have any incomplete quotes. Check the 'Current Quotes' section above for any quotes you have received. Alternatively you can start a new quote using the 'Get New Quote' section above. Any policies you have purchased will appear in the 'Purchased Policies' Section." openedAccordionChanged={openedAccordionChanged} openedAccordion={openedAccordion} />
                    </>
                }

            </div>
            <BackToTop />
        </>
    )
}